// @flow
import React, { Component, Fragment } from 'react';
import StatusMessage from 'src/components/StatusMessage/StatusMessage';

type Props = {
  children: any,
  showError?: boolean,
  showSuccess?: boolean,
  errorRenderer: string | React$Element<*>,
  successRenderer: string | React$Element<*>
};

export default class FormContainer extends Component<Props> {
  props: Props;

  renderMessage(renderer: *, messageType: Object): * {
    const messageIsString = typeof renderer === 'string';

    if (messageIsString) {
      return <StatusMessage {...messageType}>{renderer}</StatusMessage>;
    }

    return renderer;
  }

  render() {
    const {
      showError,
      showSuccess,
      errorRenderer,
      successRenderer
    } = this.props;
    return (
      <Fragment>
        {showSuccess
          ? this.renderMessage(successRenderer, {
              positive: true
            })
          : this.props.children}

        {showError
          ? this.renderMessage(errorRenderer, {
              critical: true
            })
          : null}
      </Fragment>
    );
  }
}
